export default {
    open_in_maps: 'Otvori na mapi',
    go_to_profile: 'Idite na profil',
    offer_count: '{n} usluga',
    copy_address: 'Lokacija',
    your_location: 'Vaša lokacija',
}
